import { useState } from 'react';
import { ChevronDown, Download, FileSpreadsheet, FileText, Gavel } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { AdminTimeRangePicker } from '@/components/AdminTimeRangePicker';
import { NotReadyBadge } from './DashboardNotReady';

export function ModerationDashboardFilters({
  range,
  onRangeChange,
  startDate,
  endDate,
  onExportCsv,
  exportDisabled,
  advancedExportComingSoon,
}: {
  range: string;
  onRangeChange: (range: string) => void;
  startDate?: string;
  endDate?: string;
  onExportCsv: () => void;
  exportDisabled?: boolean;
  advancedExportComingSoon?: boolean;
}) {
  const [exportOpen, setExportOpen] = useState(false);

  return (
    <div className="flex w-full flex-wrap items-center gap-3">
      <div className="flex min-w-0 items-center gap-2">
        <Gavel className="size-5 shrink-0 text-foreground" aria-hidden />
        <h1 className="text-base font-medium tracking-tight sm:text-lg">Moderation</h1>
      </div>

      <div className="ml-auto flex flex-wrap items-center gap-2">
        <AdminTimeRangePicker
          preset="admin"
          value={range}
          onChange={onRangeChange}
          {...(startDate ? { startDate } : {})}
          {...(endDate ? { endDate } : {})}
          ariaLabel="Change moderation dashboard date range"
          className="w-full min-w-[180px] sm:w-[220px]"
        />

        <Popover open={exportOpen} onOpenChange={setExportOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="inline-flex h-[49px] items-center gap-1.5 rounded-lg border border-[#272729] bg-[#101010] px-4 text-sm font-normal text-white transition-colors hover:border-[#504F4E]"
            >
              <Download className="size-3.5" />
              Export / Reports
              <ChevronDown className="size-4 opacity-60" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-56 p-1">
            <button
              type="button"
              disabled={exportDisabled}
              className="flex w-full items-center gap-2 rounded-sm px-2 py-2 text-left text-sm hover:bg-muted disabled:opacity-50"
              onClick={() => {
                onExportCsv();
                setExportOpen(false);
              }}
            >
              <FileText className="size-3.5" />
              Export current view (CSV)
            </button>
            <div className="flex items-center gap-2 rounded-sm px-2 py-2 text-sm text-muted-foreground">
              <FileSpreadsheet className="size-3.5" />
              <span className="flex-1">Excel / PDF</span>
              {advancedExportComingSoon ? (
                <NotReadyBadge
                  state="not-ready"
                  label="Soon"
                  hint="Excel and PDF reports are not wired yet. Export the current view as CSV."
                />
              ) : null}
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}
